import { FavoriteDeliveryType } from '../../../../types/checkout-info';
import { FAVORITE_DELIVERY_TYPE } from '../../../../common/constants';

export type HeaderAddressAnalyticsElementText = 'region' | 'store' | 'pickup' | 'delivery';

export const getHeaderAnalyticsElementTextByDeliveryType = (
  deliveryType: FavoriteDeliveryType,
): HeaderAddressAnalyticsElementText => {
  switch (deliveryType) {
    case FAVORITE_DELIVERY_TYPE.PICKUP_POINT:
      return 'pickup';

    case FAVORITE_DELIVERY_TYPE.PICKUP:
      return 'store';

    case FAVORITE_DELIVERY_TYPE.HOME_DELIVERY:
      return 'delivery';

    case FAVORITE_DELIVERY_TYPE.REGION:
      return 'region';

    default:
      return 'region';
  }
};
